export let API_URL = '';

export const initializeConfig = async () => {
  // Rely on React Proxy directly
};

export const getApiUrl = () => API_URL;
